module.exports = {"451423100":"龙州镇","451423101":"下冻镇","451423102":"水口镇","451423103":"金龙镇","451423104":"响水镇","451423201":"八角乡","451423202":"上降乡","451423203":"彬桥乡","451423204":"上龙乡","451423205":"武德乡","451423206":"逐卜乡","451423207":"上金乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451423.json
// module id = 2179
// module chunks = 0